export const randomBetween = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const isMobile = /(android|iphone|blackberry|webos)/i.test(
  navigator.userAgent
);

export const isIos = /iphone/i.test(navigator.userAgent);
